export default __webpack_public_path__ + "static/media/help6.aa3d1ef6.svg";